export default "/images/logo-17.png?f92ca1acbfeaa3f3da7bf753ce34cfbe";